import script from "./ChartNoData.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChartNoData.vue?vue&type=script&lang=ts&setup=true"

import "./ChartNoData.vue?vue&type=style&index=0&id=087ee305&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-087ee305"]])

export default __exports__